import { useEffect } from 'react';
import { func, object } from 'prop-types';
import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setViewWidth } from '../../modules/view';
import MyBoxPage from '../MyBoxPage/MyBoxPage';
import './App.css';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { GlobalFooter } from '@fff-web/fff-global-footer';
import { GlobalNav } from '@fff-web/fff-global-nav';
import env from '../../utils/env';
import optimizelyClientInstance from '../../utils/optimizely/client';
import { getUUID } from '../../utils/optimizely/getUUID';

const App = ({ setViewWidthAction, userData }) => {
  const { chatbotAppliedLab: showChatbot } = useFlags();
  const optimizelyUserId = String(userData?.user?.wooId ?? getUUID());

  useEffect(
    () => window.addEventListener('resize', () => setViewWidthAction(window.innerWidth)),
    [setViewWidthAction],
  );

  return (
    <OptimizelyProvider optimizely={optimizelyClientInstance} user={{ id: optimizelyUserId }}>
      <div>
        <GlobalNav />
        <main className="my-box-page">
          <Routes>
            <Route path="*" element={<MyBoxPage userData={userData} />} />
          </Routes>
        </main>
        <GlobalFooter
          chatbotConfig={{ agentId: env.appliedLabsChatbotAgentId, hideWidget: !showChatbot }}
        />
      </div>
    </OptimizelyProvider>
  );
};

const mS = (state) => ({
  isMobile: state.view.isMobile,
});

const mD = (dispatch) =>
  bindActionCreators(
    {
      setViewWidthAction: setViewWidth,
    },
    dispatch,
  );

App.propTypes = {
  setViewWidthAction: func.isRequired,
  userData: object.isRequired,
};

export default connect(mS, mD)(App);
